import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import authAPI from '../../api/authAPI'
import userAPI from '../../api/userAPI'
import { getConfig } from './configSlice'

const initState = {
    _id: "",
    identity: "",
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    phoneNumber: "",
    designation: "",
    department: "",
    addressInfo: {
        address: "",
        zipCode: "",
        country: "",
        city: "",
        map: ""
    },
    shift: {
        shiftName: "",
        fromTime: "",
        toTime: ""
    },
    role: {
        _id: "",
        permissions: []
    },
    status: "",
    deleteStatus: "",
    userImage: "",
    createdBy: ""
}

export const authLogin = createAsyncThunk('retaillogin', async (payload, thunkAPI) => {
    try {
        const { username, password, storelocation, counter } = payload
        const res = await authAPI.login(username, password, storelocation, counter)
        if (res) {
            localStorage.setItem('counter', counter)
            thunkAPI.dispatch(getConfig())
        }
        return res.data.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

export const authLogout = createAsyncThunk('logout', async (_, thunkAPI) => {
    try {
        const res = await authAPI.logout()
        localStorage.removeItem('counter')
        return res.data.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

export const getUserProfile = createAsyncThunk('user/profile', async (_, thunkAPI) => {
    try {
        const res = await userAPI.getUserProfile()
        return res.data.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

export const checkAuthSession = createAsyncThunk('verifyToken', async (_, thunkAPI) => {
    try {
        const counterId = localStorage.getItem('counter')
        console.log("counterId: ", counterId)
        const res = await authAPI.verifyToken(counterId)
        if (res.data.isAuth) {
            thunkAPI.dispatch(getUserProfile())
            thunkAPI.dispatch(getConfig())
        }
        return res.data.isAuth
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

// export const checkAuth = createAsyncThunk('verifyToken', async (_, thunkAPI) => {
//     try {
//         const res = await authAPI.verifyToken()
//         return res.data.isAuth
//     } catch (error) {
//         return thunkAPI.rejectWithValue(error)
//     }
// })

const usersSlice = createSlice({
    name: 'user',
    initialState: {
        user: initState,
        status: 'loading',
        message: '',
        isLoggedIn: false,
        validateMsg: {}
    },
    reducers: {
        clearUser: (state, action) => {
            state.user = initState
            state.status = null
            state.message = ''
            state.isLoggedIn = false
        }
    },
    extraReducers: {
        // [authLogin.pending]: (state, action) => {
        //     state.status = 'loading'
        // },
        [authLogin.fulfilled]: (state, { payload }) => {
            state.user = payload
            state.status = 'success'
            state.message = ''
            state.isLoggedIn = true
            state.validateMsg = {}
        },
        [authLogin.rejected]: (state, { payload }) => {
            state.status = 'failed'
            state.message = payload.message
            state.validateMsg = payload.response.data
        },
        [authLogout.pending]: (state, action) => {
            state.status = 'loading'
        },
        [authLogout.fulfilled]: (state, { payload }) => {
            state.user = initState
            state.status = 'success'
            state.isLoggedIn = false
        },
        [authLogout.rejected]: (state, { payload }) => {
            state.status = 'failed'
            state.message = payload.message
        },
        [getUserProfile.pending]: (state, action) => {
            state.status = 'loading'
        },
        [getUserProfile.fulfilled]: (state, { payload }) => {
            state.user = payload
            state.status = 'success'
            state.isLoggedIn = true
        },
        [getUserProfile.rejected]: (state, { payload }) => {
            state.status = 'failed'
            state.message = payload.message
            state.isLoggedIn = false
        },
        [checkAuthSession.pending]: (state, action) => {
            state.status = 'loading'
        },
        [checkAuthSession.fulfilled]: (state, { payload }) => {
            if (payload) {
                state.status = 'success'
                state.isLoggedIn = true
            } else {
                state.user = initState
                state.status = 'success'
                state.isLoggedIn = false
            }
        },
        [checkAuthSession.rejected]: (state, { payload }) => {
            state.status = 'failed'
            state.message = payload.message
            state.isLoggedIn = false
        },
    },
})

export const { clearUser } = usersSlice.actions

export default usersSlice.reducer